const $ = window.$, _ = window._
import React from "react"
import ButtonLoader from 'js/studios/shared/button_loader'
import {classNames, LinkFormattedText} from 'js/studios/shared/utils'
import {getErrors} from 'js/studios/shared/forms/utils'
import {loginFacebook, sendRequest, GoogleLoginButton, googleLoginAvailable, AppleSigninButton, appleSigninAvailable} from '../auth'
import {trackEventSP} from 'js/studios/shared/tracking'
import {SvgIcon} from 'js/studios/shared/svg_icons'

export class LoginPanel extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      'email': '',
      'password': '',
      'errors': {},
      'fbButtonLoading': false,
      'loginButtonLoading': false
    }

    this.REQUIRED_FIELDS = ['email', 'password']
  }

  componentDidMount(){
    this.emailInput.focus()
  }

  updateField(field, e){
    let newState = {}
    newState[field] = $(e.target).val()
    newState['errors'] = Object.assign({}, this.state.errors)
    delete newState['errors'][field]
    delete newState['errors']['global']
    this.setState(newState)
  }

  forgotYourPassword(e){
    e.preventDefault()
    this.props.navigateToPanel('forgot-password')
  }

  emailLogin(e){
    e.preventDefault()
    let data = _.pick(this.state, 'email', 'password', 'firstName', 'lastName')
    data.agreement = true

    let errors = getErrors(data, this.REQUIRED_FIELDS),
        isValid = _.isEmpty(errors)
    this.setState({errors: errors})
    if (isValid){
      this.setState({
        'loginButtonLoading': true
      })
      sendRequest('login', _.pick(this.state, 'email', 'password'))
        .then(resp => {
          this.trackSubmit('Customer logs in', true, '', resp.email)
          this.props.onSuccess(resp)
        })
        .catch(errorMessage => {
          this.trackSubmit('Customer logs in', false, errorMessage, data.email)
          this.setState({
            loginButtonLoading: false,
            errors: {
              'global': errorMessage
            }
          })
        })
    }
  }

  trackSubmit(name, success, reason_for_fail, email){
    trackEventSP(name, 'Customer sign up', {
      'success': success,
      'reason_for_fail': reason_for_fail,
      'email_address': email
    })
  }

  fbLogin(e){
    e.preventDefault()
    this.setState({
      'fbButtonLoading': true
    })

    loginFacebook({})
      .then(resp => {
        this.trackSubmit('Customer Facebook sign up submitted', true, '', resp.email)
        this.props.onSuccess(resp)
      })
      .catch(errorMessage => {
        this.trackSubmit('Customer Facebook sign up submitted', false, errorMessage, '')
        this.setState({
          fbButtonLoading: false,
          errors: {
            'global': errorMessage
          }
        })
      })
  }

  googleLogin(result) {
    if (result.error) {
      this.trackSubmit('Customer Google sign up submitted', false, result.error, '')
      this.setState({ errors: { global: result.error } })
    } else {
      this.trackSubmit('Customer Google sign up submitted', true, '', result.email)
      this.props.onSuccess(result)
    }
  }

  appleLogin(result) {
    if (result.error) {
      this.trackSubmit('Customer Apple sign up submitted', false, result.error, '')
      this.setState({ errors: { global: result.error } })
    } else {
      this.trackSubmit('Customer Apple sign up submitted', true, '', result.email)
      this.props.onSuccess(result)
    }
  }

  render() {
    let globalError = null
    if (this.state.errors.global){
      globalError = <div className="error_message"><LinkFormattedText>{this.state.errors.global}</LinkFormattedText></div>
    }

    return (
      <div className="panel_wrapper">
        <div>
          <form className="inner" onSubmit={this.emailLogin.bind(this)}>
            <h2>Log in to your account</h2>
            <fieldset>
              <input
                type="text"
                name="email"
                ref={(node) => this.emailInput = node}
                className={classNames('form-input', {error: this.state.errors['email']})}
                aria-label="Email address"
                placeholder="Email address"
                value={this.state.email}
                onChange={this.updateField.bind(this, 'email')}
                />

              <input
                type="password"
                name="password"
                className={classNames('form-input password-input', {error: this.state.errors['password']})}
                aria-label="Password"
                placeholder="Password"
                value={this.state.password}
                onChange={this.updateField.bind(this, 'password')}
                />
              <a href="#" className="forgot_password" onClick={this.forgotYourPassword.bind(this)}>Forgot your password?</a>

              {globalError}
            </fieldset>

            <fieldset>
              <ButtonLoader type="submit" className="btn btn-lg btn-primary login_button" loading={this.state.loginButtonLoading} onClick={this.emailLogin.bind(this)}>Log in</ButtonLoader>
              <div className="divider">or</div>
              {googleLoginAvailable() && <GoogleLoginButton handler={this.googleLogin.bind(this)} />}
              {appleSigninAvailable() && <AppleSigninButton handler={this.appleLogin.bind(this)} />}
              <ButtonLoader type="button" className="btn btn-primary fb-button" loading={this.state.fbButtonLoading} onClick={this.fbLogin.bind(this)}><SvgIcon name="icon-facebook" color="#fff" size="20px" />Log in with Facebook</ButtonLoader>
            </fieldset>

            <div className="signup_cta">
              <div className="divider"></div>
              <p>Don't have an account yet?</p>
              <a className="btn btn-md btn-primary" href={window.cm.urls['project-creation']}>Start a project now</a>
            </div>
          </form>
        </div>
      </div>
    )
  }
}
